var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "form-horizontal col-xs-10" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { staticClass: "control-label col-sm-4" }, [
          _vm._v("Button Text:"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-8" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.buttonText,
                  expression: "buttonText",
                },
              ],
              staticClass: "form-control",
              attrs: {
                name: "button_text",
                type: "text",
                placeholder: "eg: Yes I love dogs!",
              },
              domProps: { value: _vm.buttonText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.buttonText = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            !_vm.validation.button_text.required
              ? _c("div", { staticClass: "help-block" }, [
                  _vm._v("Text is required"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("help-block", { attrs: { field: "button_text" } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { staticClass: "control-label col-sm-4" }, [
            _vm._v("Assign Tags:"),
          ]),
          _vm._v(" "),
          _c("tags", {
            staticClass: "col-sm-8",
            attrs: { creationType: "theme", "allow-create": false },
            model: {
              value: _vm.tags,
              callback: function ($$v) {
                _vm.tags = $$v
              },
              expression: "tags",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.extraField
      ? _c(
          "a",
          {
            staticClass: "btn btn-circle btn-danger col-xs-2",
            on: { click: _vm.removeActionButtonByIndex },
          },
          [_c("i", { staticClass: "fa fa-minus" })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }